/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useMemo } from 'react';
import { getServicesAll, getServicesQtd } from '../../../../../../services/servicesService';
import { Loading } from '../../../../../components/Loadings/loading';
import { SearchInputV3 } from '../../../../../components/SearchInputV3';
import { useToast } from '../../../../../components/Toats';
import { ModalDeleteOS } from '../ModalDeleteOS';
import { ModalDetailsOS } from '../ModalDetailsOS';
import { OrderServiceChecklistBoard } from '../../../../../../components/OrderServiceChecklist/OrderServiceChecklistBoard';
import { ClientOrderServiceList } from '../../../../../../components/OrderServiceChecklist/ClientOrderServiceList';
import checklistLayoutStyles from '../../../../../../components/OrderServiceChecklist/orderServiceChecklistLayout.module.css';
import { ModalAddUpdateOrderService } from './components/ModalAddEditOrderService';
import { useAuth } from '../../../../../../modules/auth';
import { getCollaboratosAll } from '../../../../../../services/collaboratorsService';
import { getClientAll } from '../../../../../../services/clientService';
import { ModalTemplateOS } from '../ModalTemplateOS';
import { OrderServiceToolbar } from '../../../../../../components/OrderServiceChecklist/OrderServiceToolbar';
import listLayoutStyles from '../../../../../components/ListTableLayout/listTableLayout.module.css';

import useSize from '../../../../../../hooks/useSize';
import { PaginationTablePlants } from '../../../../../dashboard/TablePlants/components/Pagination';
import { useQuery } from 'react-query';

type Props = {
    className: string;
    refreshPage : boolean; 
    setRefreshPage: any;
  }


type Paginations = {
  page: number,
  limit: number,
  total: number,
  qtdPages: number
}

type SetPaginations = {
  start: number;
  end: number;
}

const PAGE_SIZE = 10
  
  const TableOrderOfService: React.FC<Props> = ({className, refreshPage}) => {
    
    const [filterName, setFilterName] = useState<string>("");
    const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  //   const [showCreateAppModalDelete, setShowCreateAppModalDelete] = useState<boolean>(false)
    //const [showCreateAppModalDetails, setShowCreateAppModalDetails] = useState<boolean>(false)
    const [myOrderService, setMyOrderService] = useState<any | null>(null);
    //const [orderOfServices, setOrderOfServices] = useState<any>([]);
    //const [orderOfServicesQtd, setOrderOfServicesQtd] = useState<any>([]);
    const { toggleToast } = useToast();
    //const [orderOfServiceLoading, setOrderOfServicesLoading] = useState<boolean>(false)
    //const [orderOfServiceQtdLoading, setOrderOfServicesQtdLoading] = useState<boolean>(false)
    const [showModalDetails, setShowModalDetails] = useState<boolean>(false)
    const [showModalDelete, setShowModalDelete] = useState<boolean>(false)
    const [showModalTemplate, setShowModalTemplate] = useState<boolean>(false)
    const [filterStatus, setFilterStatus] = useState<string>("")
    const [collaborators, setCollaborators] = useState<any[]>([]);
    const [clients, setClients] = useState<any[]>([]);
    const [filterDateInit, setFilterDateInit] = useState<any>("");
    const [filterDateEnd, setFilterDateEnd] = useState<any>("");
    const [filterCollaborator, setFilterCollaborator] = useState<any>("");
    const [filterClient, setFilterClient] = useState<any>("");
    const {currentUser} = useAuth();
    const {height, width} = useSize();

    const [pagination, setPagination] = useState<Paginations>({
      page: 1,
      limit: PAGE_SIZE,
      total: 0,
      qtdPages: 1
    });
  
    const [qtd, setQtd] = useState<SetPaginations>({
      start: 0,
      end: PAGE_SIZE,
    });


    const { data: orderOfServices, isLoading: orderOfServiceLoading, refetch: refetchOrderOfServices } = useQuery<any>(
      ["getMyOrderOfServices", 
        refreshPage,
        filterStatus,
        filterCollaborator,
        filterDateInit,
        filterDateEnd,
        filterClient,
        filterName
      ],
      async () => {
        const myServices = await getServicesAll(
          filterStatus,
          "",
          "",
          filterCollaborator,
          filterDateInit,
          filterDateEnd,
          filterClient,
          filterName
        )
        return myServices
      },
      {
        onError: (error) => {
          toggleToast("Erro ao buscar as ordens de serviço!", "error")
        },
      }
    )


    const { data: orderOfServicesQtd, isLoading: orderOfServiceQtdLoading, refetch: refetchOrderOfServicesQtd } = useQuery<any>(
      ["getServicesQtdAll", refreshPage],
      async () => {
        const myServicesQtd = await getServicesQtd()
        return myServicesQtd
      },
      {
        onError: (error) => {
          toggleToast("Erro ao buscar as ordens de serviço!", "error")
        },
      }
    )

  // const getServicesQtdAll = async () => {
  //   try {
  //     setOrderOfServicesQtdLoading(true)
  //     const myServicesQtd = await getServicesQtd()
  //     setOrderOfServicesQtd(myServicesQtd)
  
  //   } catch (error) {
  //     console.log(error)
  //     toggleToast("Erro ao buscar os status!", "error")
  //   }finally{
  //     setOrderOfServicesQtdLoading(false)
  //   }
  // }

  const getUsersAllCollaborators = async () => {
    try {
      //setLoadingCollaborators(true)
      const collaboratos = await getCollaboratosAll()
      setCollaborators(Array.isArray(collaboratos) ? collaboratos : [])

    } catch (error) {
      console.log(error)
      toggleToast("Erro ao buscar os colaboradores. ", "error")

    }finally{
      //setLoadingCollaborators(false)
    }
  }

  const getClients = async () => {
    try {
      const myClient = await getClientAll()
      setClients(Array.isArray(myClient) ? myClient : myClient ? [myClient] : [])

    } catch (error) {
      console.log(error)
      toggleToast("Erro ao buscar os clientes!", "error")
    }finally{
    }
  }
  
  
  const ordersSource = useMemo(() => {
    const source = orderOfServices || [];
    return Array.isArray(source) ? source : [];
  }, [orderOfServices]);

  const paginatedOrders = useMemo(() => {
    const start = (pagination.page - 1) * pagination.limit;
    return ordersSource.slice(start, start + pagination.limit);
  }, [ordersSource, pagination.page, pagination.limit]);

  const tablePagination = useMemo(
    () => ({
      ...pagination,
      total: ordersSource.length,
      qtdPages: Math.max(1, Math.ceil(ordersSource.length / pagination.limit) || 1),
    }),
    [pagination, ordersSource]
  );

  useEffect(() => {
    const total = ordersSource.length;
    const start = total === 0 ? 0 : (pagination.page - 1) * pagination.limit + 1;
    const end = Math.min(pagination.page * pagination.limit, total);
    setQtd({ start, end: end === 0 && total > 0 ? pagination.limit : end });
  }, [pagination.page, pagination.limit, ordersSource.length]);

  useEffect(() => {
    setPagination((prev) => ({ ...prev, page: 1 }));
  }, [filterStatus, filterCollaborator, filterDateInit, filterDateEnd, filterClient, filterName]);

  useEffect(() => {
    const qtdPages = Math.max(1, Math.ceil(ordersSource.length / pagination.limit) || 1);
    if (pagination.page > qtdPages) {
      setPagination((prev) => ({ ...prev, page: qtdPages }));
    }
  }, [ordersSource.length, pagination.limit, pagination.page]);

  const refresh = () => {
    refetchOrderOfServices()
    refetchOrderOfServicesQtd()
  }

  const adjustOrderServiceDates = (orderService: any) => {
    if (orderService.dateInit) {
      const date = new Date(orderService.dateInit)
      date.setHours(date.getHours() + 3)
      orderService.dateInit = date.toISOString()
    }
    if (orderService.dateEnd) {
      const date = new Date(orderService.dateEnd)
      date.setHours(date.getHours() + 3)
      orderService.dateEnd = date.toISOString()
    }
    return orderService
  }

  const openOrderDetails = (orderService: any) => {
    setMyOrderService(orderService)
    setShowModalDetails(true)
  }

  const prepareOrdersList = (items: any[]) => {
    if (!items?.length) return []
    return items.map((order) => adjustOrderServiceDates(order))
  }

  const isClientUser = currentUser?.role?.slug === 'CLIENTE'

  const checklistBoardProps = {
    filterStatus,
    orderOfServicesQtd,
    onOpenDetails: openOrderDetails,
    refresh,
    setShowModalDelete,
    setMyOrderService,
    setShowCreateAppModal,
    setShowModalTemplate,
  }
  
  useEffect(() => {
    //getReportServices()
    //getServicesQtdAll()
    getUsersAllCollaborators()
    getClients()
    //getReportServices()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshPage]);
  

  if (orderOfServiceQtdLoading) {
    return (
      <div className='spinnerLoadingDashboard'>
        <Loading myClass='spinner-border spinnerDashboard'/>
      </div>
    );
  }

    
    return (
      <div className={`${className}`}>
        {/* begin::Header */}
        <OrderServiceToolbar
          search={
            <SearchInputV3
              className={`form-control form-control-sm ${listLayoutStyles.listSearch}`}
              placeholder='Buscar por Nº O.S, título ou cliente'
              setMySearch={setFilterName}
              style={{width: '100%'}}
            />
          }
          filterStatus={filterStatus}
          setFilterStatus={setFilterStatus}
          orderOfServicesQtd={orderOfServicesQtd}
          filterDateInit={filterDateInit}
          setFilterDateInit={setFilterDateInit}
          filterDateEnd={filterDateEnd}
          setFilterDateEnd={setFilterDateEnd}
          filterCollaborator={filterCollaborator}
          setFilterCollaborator={setFilterCollaborator}
          filterClient={filterClient}
          setFilterClient={setFilterClient}
          collaborators={collaborators}
          clients={clients}
          showClientFilter={!!(currentUser && currentUser.role && currentUser.role.slug !== 'CLIENTE')}
          canCreate={!!(currentUser && currentUser.role && currentUser.role.slug && currentUser.role.slug !== 'CLIENTE')}
          onCreate={() => setShowCreateAppModal(true)}
        />

        <div
          className={`py-3 ${checklistLayoutStyles.osListPanel}`}
          style={
            width >= 992
              ? {
                  overflow: 'auto',
                  height: '100%',
                  minHeight: '60vh'
                }
              : undefined
          }
        >
          <div className={`table-responsive ${checklistLayoutStyles.osTableWrap}`}>
            <table className='table table-row-dashed table-hover table-row-gray-300 align-middle gs-0 gy-4'>
              {/* end::Table head */}
              {/* begin::Table body */}
                {
                  orderOfServiceLoading ? 
                    <div className='spinnerLoadingDashboard'>
                      <Loading myClass='spinner-border spinnerDashboard'/>
                    </div>
                  
                  :
                  (
                    <tbody>
                      <tr>
                        <td colSpan={6} className={checklistLayoutStyles.osChecklistCell}>
                          {ordersSource.length > 0 ? (
                            isClientUser ? (
                              <ClientOrderServiceList
                                orders={prepareOrdersList(paginatedOrders)}
                                onOpenDetails={openOrderDetails}
                              />
                            ) : (
                              <OrderServiceChecklistBoard
                                orders={prepareOrdersList(paginatedOrders)}
                                {...checklistBoardProps}
                              />
                            )
                          ) : (
                            <div className={checklistLayoutStyles.osChecklistEmpty}>
                              <span className='text-muted fw-semibold fs-5'>
                                Ordens de serviços não encontradas!
                              </span>
                            </div>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  )
                  }
                
            </table>
          </div>

          <PaginationTablePlants 
            pagination={tablePagination}
            setPagination={setPagination}
            qtd={qtd}
          />
        </div>

          <ModalAddUpdateOrderService
            show={showCreateAppModal}
            id={myOrderService ? myOrderService.id : undefined} 
            data={myOrderService ? myOrderService : undefined}
            handleClose={() => {
              setMyOrderService(null)
              setShowCreateAppModal(false)
              refresh()
            }} 
          />
          <ModalDeleteOS
            show={showModalDelete}
            data={myOrderService ? myOrderService : undefined}
            id={myOrderService ? myOrderService.id : undefined} 
            handleClose={() => {
              setMyOrderService(null)
              setShowModalDelete(false)
              refresh()
            }} 
          />

          <ModalDetailsOS
            show={showModalDetails}
            data={myOrderService ? myOrderService : undefined}
            id={myOrderService ? myOrderService.id : undefined} 
            handleClose={() => {
              setMyOrderService(null)
              setShowModalDetails(false)
              refresh()
            }} 
          />
  
        {<ModalTemplateOS
          show={showModalTemplate}
          id={myOrderService ? myOrderService.id : undefined} 
          handleClose={() => {
            setMyOrderService(null)
            setShowModalTemplate(false)
            refresh()
          }} 
        />}
          {/* <ModalDetailsClient
            show={showCreateAppModalDetails}
            id={myClient ? myClient.id : undefined} 
            handleClose={() => {
              setMyClient(null)
              setShowCreateAppModalDetails(false)
              refresh()
            }} 
          /> */}
        {/* begin::Body */}
      </div>
    )
  }
  
  export {TableOrderOfService}